export const tableWrapper = () => {
  const wysiwyg = document.querySelector('.wysiwyg');
  if (wysiwyg) {
    const iframe = document.querySelector('iframe');
    if (iframe) {
      iframe.parentNode.classList.add('iframe-active');
    }
    const table = document.querySelector('table');
    if (table) {
      table.outerHTML = `<div class="table-wrapper">${table.outerHTML}</div>`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/js-component/table-wrapper.js